import styled from 'styled-components'

import { PrimaryButton, SecondaryButton } from '@tuhi/components'
import { RouteUrl } from 'app/routes'
import { Link } from 'react-router-dom'
import { FC } from 'react'

const Container = styled.div`
    display: flex;
    gap: 20px;
    justify-content: flex-end; /* Push the buttons to the right */
    align-items: center;
`

export const AuthenticationButtons: FC = () => {
    return (
        <Container>
            <Link to={RouteUrl.LogIn.path}>
                <SecondaryButton height="large" width="hug">
                    {RouteUrl.LogIn.name}
                </SecondaryButton>
            </Link>

            <Link to={RouteUrl.SignUp.segment}>
                <PrimaryButton height="large" width="hug">
                    {RouteUrl.SignUp.name}
                </PrimaryButton>
            </Link>
        </Container>
    )
}
